module.exports = __webpack_public_path__ + "static/plan-61e1b5a5e63768aff91ebd805e1bd009.svg";